import { createFileRoute } from '@tanstack/react-router';
import { WarehouseTable } from '@/components/Pages/Warehouses/WarehouseTable';
import { CreateEditWarehouseModal } from '@/components/Pages/Warehouses/CreateEditWarehouseModal';
import { Box } from '@mui/joy';
import { useAuth } from '@/contexts/AuthContext';

export const Route = createFileRoute('/_protected/warehouses/')({
  component: WarehousesPage,
});

function WarehousesPage() {
  const { isAdmin, isSuperAdmin } = useAuth();
  const showActions = isAdmin || isSuperAdmin;

  return (
    <Box>
      {showActions && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
          <CreateEditWarehouseModal />
        </Box>
      )}
      <WarehouseTable />
    </Box>
  );
}
